/* TripTrike v4 — theme behaviour. No dependencies, no build step.
   Sections: helpers, header, announcement, overlays, category panel, toast,
   cart, header search, rails, gallery, variants, sticky buy, footer,
   watchlist + recently viewed, view switch, hero carousel. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mq = function (q) { return window.matchMedia(q).matches; };
  var isSmall = function () { return mq('(max-width:999px)'); };
  var reduce = function () { return mq('(prefers-reduced-motion: reduce)'); };
  var T = window.TT || {};

  function money(cents) {
    var f = T.moneyFormat;
    var v = cents / 100;
    if (!f) return '$' + v.toFixed(2);
    return f
      .replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(v).toString());
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  };
  function handles(k) {
    var l = store.get(k, []);
    return Array.isArray(l) ? l.filter(function (h) { return typeof h === 'string' && /^[a-z0-9-]+$/.test(h); }) : [];
  }

  var ICON = {
    heart: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" width="20" height="20"><path d="M12 20.2s-7.6-4.5-9.3-9.4C1.6 7.4 3.8 4 7.3 4c2 0 3.6 1.1 4.7 2.7C13.1 5.1 14.7 4 16.7 4c3.5 0 5.7 3.4 4.6 6.8-1.7 4.9-9.3 9.4-9.3 9.4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
    add: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" width="22" height="22"><path d="M2.5 3.5h2.6l2.3 11.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2l1.6-7.3H6.2" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 8.2v4.6M10.7 10.5h4.6" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/><circle cx="9.6" cy="19.8" r="1.4" fill="currentColor"/><circle cx="17.2" cy="19.8" r="1.4" fill="currentColor"/></svg>'
  };

  /* Product card from a /products/<handle>.js payload — same markup as snippets/tt-product-card. */
  function cardHtml(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    var imgs = p.images || [];
    var a = sized(p.featured_image || imgs[0], 500), b = imgs[1] ? sized(imgs[1], 500) : '';
    var thr = T.freeShip || 0, fee = T.shipFee || 0;
    var price = p.price_varies ? money(p.price_min) + ' <small>to</small> ' + money(p.price_max) : money(v.price || p.price);
    var ship = thr > 0 && (v.price || p.price) >= thr ? '<span class="card__ship card__ship--free">Free delivery</span>'
      : (fee > 0 ? '<span class="card__ship">+' + money(fee) + ' delivery</span>' : '');
    var add = '';
    if (p.available) {
      add = (p.variants || []).length === 1
        ? '<button type="button" class="card__add" data-quickadd="' + v.id + '" aria-label="Add ' + esc(p.title) + ' to cart">' + ICON.add + '<span class="card__add-l">Add to cart</span><span class="btn__spin"></span></button>'
        : '<a class="card__add" href="' + esc(p.url) + '" aria-label="Choose options for ' + esc(p.title) + '">' + ICON.add + '<span class="card__add-l">See options</span></a>';
    }
    return '<article class="card" data-card="' + esc(p.handle) + '"><div class="card__frame">' +
      '<a class="card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
        (a ? '<img class="card__img card__img--a" src="' + esc(a) + '" alt="' + esc(p.title) + '" width="500" height="500" loading="lazy" decoding="async">' : '<span class="ph">No image</span>') +
        (b ? '<img class="card__img card__img--b" src="' + esc(b) + '" alt="" width="500" height="500" loading="lazy" decoding="async">' : '') +
      '</a>' +
      (p.available ? '' : '<span class="card__tags"><span class="tag tag--out">Out of stock</span></span>') +
      '<button type="button" class="card__fav" data-watch="' + esc(p.handle) + '" aria-pressed="false" aria-label="Add ' + esc(p.title) + ' to your Watchlist">' + ICON.heart + '</button>' +
      add + '</div><div class="card__body">' +
      '<a class="card__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="card__cond">Brand New' + (p.type ? ' · ' + esc(p.type) : '') + '</span>' +
      '<span class="price"><span class="price__now">' + price + '</span></span>' + ship +
      '</div></article>';
  }
  function fetchProducts(list) {
    return Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : (r.status === 404 ? { _gone: h } : null); })
        .catch(function () { return null; });
    }));
  }

  /* ---------------------------------------------------------------- header
     The brand bar is sticky. On phones it slides away while scrolling down
     and comes back on the way up, so it never eats a sixth of the screen. */
  var hdr = $('[data-hdr]');
  var bar = $('[data-hdr-bar]');

  function measure() {
    if (!bar) return;
    var h = Math.round(bar.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--hdr-h', h + 'px');
  }
  measure();
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);

  var searchOpen = false;
  if (hdr) {
    var lastY = window.scrollY, ticking = false;
    var onScroll = function () {
      var y = window.scrollY;
      hdr.classList.toggle('is-stuck', y > 4);
      if (bar) {
        if (isSmall() && !reduce() && !searchOpen) {
          if (y > 320 && y - lastY > 6) bar.classList.add('is-away');
          else if (lastY - y > 6 || y < 140) bar.classList.remove('is-away');
        } else {
          bar.classList.remove('is-away');
        }
      }
      lastY = y;
      ticking = false;
    };
    onScroll();
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
  }

  /* ---------------------------------------------------- announcement ticker */
  (function () {
    var wrapEl = $('[data-ann]');
    if (!wrapEl) return;
    var msgs = $$('[data-ann-msg]', wrapEl);
    if (msgs.length < 2) return;
    var i = 0, timer;
    var delay = parseInt(wrapEl.getAttribute('data-ann-delay'), 10) || 5000;
    function go(n) {
      msgs[i].classList.remove('is-on');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-on');
    }
    function start() {
      if (reduce()) return;
      clearInterval(timer);
      timer = setInterval(function () { go(i + 1); }, delay);
    }
    wrapEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ann-nav]');
      if (!b) return;
      go(i + (b.getAttribute('data-ann-nav') === 'next' ? 1 : -1));
      start();
    });
    wrapEl.addEventListener('mouseenter', function () { clearInterval(timer); });
    wrapEl.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearInterval(timer); else start();
    });
    start();
  })();

  /* -------------------------------------------------------- overlay manager */
  var scrim = $('[data-scrim]');
  var openEl = null, lastFocus = null, lockY = 0;

  function lock(on) {
    var b = document.body;
    if (on) {
      lockY = window.scrollY;
      b.style.position = 'fixed';
      b.style.top = (-lockY) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
      b.classList.add('is-locked');
    } else {
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      b.classList.remove('is-locked');
      window.scrollTo(0, lockY);
    }
  }

  function openPanel(el) {
    if (!el) return;
    if (openEl === el) return;
    if (openEl) closePanel(true);
    closeDept();
    lastFocus = document.activeElement;
    openEl = el;
    if (bar) bar.classList.remove('is-away');
    el.classList.add('is-on');
    el.removeAttribute('aria-hidden');
    if (scrim && !el.hasAttribute('data-no-scrim')) scrim.classList.add('is-on');
    lock(true);
    var f = el.querySelector('[data-autofocus]') ||
            el.querySelector('button:not([disabled]),a[href],input,select,textarea');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 90);
  }

  function closePanel(keepLock) {
    if (!openEl) return;
    openEl.classList.remove('is-on');
    openEl.setAttribute('aria-hidden', 'true');
    openEl = null;
    if (scrim) scrim.classList.remove('is-on');
    if (!keepLock) lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) {
      var target = $(o.getAttribute('data-open'));
      // the filter column is a drawer only on phones; on desktop it is already on screen
      if (target && target.classList.contains('plp__side') && !isSmall()) return;
      e.preventDefault();
      openPanel(target);
      return;
    }
    if (e.target.closest('[data-close]') && openEl) { e.preventDefault(); closePanel(); }
  });
  if (scrim) scrim.addEventListener('click', function () { closePanel(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (openEl) { closePanel(); return; }
      closeDept(true);
      closeSearch();
      return;
    }
    if (e.key !== 'Tab' || !openEl) return;
    var f = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', openEl)
      .filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------------- "All categories" panel */
  var deptBtn = $('[data-dept-toggle]');
  var deptPanel = $('[data-dept-panel]');
  function closeDept(refocus) {
    if (!deptBtn || !deptPanel || deptPanel.hidden) return;
    deptPanel.hidden = true;
    deptBtn.setAttribute('aria-expanded', 'false');
    if (refocus) deptBtn.focus();
  }
  if (deptBtn && deptPanel) {
    deptBtn.addEventListener('click', function () {
      var open = deptPanel.hidden;
      deptPanel.hidden = !open;
      deptBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) closeSearch();
    });
    document.addEventListener('click', function (e) {
      if (!deptPanel.hidden && !e.target.closest('[data-dept]')) closeDept();
    });
  }

  /* ----------------------------------------------------------------- toast */
  var toastTimer;
  function toast(msg, tone) {
    var t = $('[data-toast]');
    if (!t) return;
    $('[data-toast-msg]', t).textContent = msg;
    t.classList.toggle('is-err', tone === 'err');
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  /* ------------------------------------------------------------------ cart */
  var onCartPage = document.body.classList.contains('tmpl-cart');

  function lineHtml(i) {
    var img = i.image ? sized(i.image, 200) : '';
    var opts = (i.options_with_values || [])
      .filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
    var sale = i.original_line_price > i.final_line_price;
    return '<div class="line" data-key="' + esc(i.key) + '">' +
      '<a href="' + esc(i.url) + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img class="line__img" src="' + esc(img) + '" alt="" width="76" height="76" loading="lazy">'
             : '<span class="line__img"></span>') +
      '</a>' +
      '<div>' +
        '<a href="' + esc(i.url) + '" class="line__t">' + esc(i.product_title) + '</a>' +
        (opts ? '<div class="line__v">' + opts + '</div>' : '') +
        '<div class="line__row">' +
          '<div class="qty qty--sm">' +
            '<button type="button" data-cq="' + esc(i.key) + '" data-d="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<input type="text" value="' + i.quantity + '" data-cqi="' + esc(i.key) + '" aria-label="Quantity" inputmode="numeric">' +
            '<button type="button" data-cq="' + esc(i.key) + '" data-d="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<strong class="tnum">' + money(i.final_line_price) +
            (sale ? ' <s class="line__v" style="font-weight:400">' + money(i.original_line_price) + '</s>' : '') +
          '</strong>' +
        '</div>' +
        '<button type="button" class="line__rm" data-crm="' + esc(i.key) + '">Remove</button>' +
      '</div></div>';
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      n.hidden = cart.item_count === 0;
    });
    $$('[data-cart-count-label]').forEach(function (n) {
      n.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    });
    var body = $('[data-cart-body]');
    if (body) {
      if (!cart.item_count) {
        body.innerHTML = '<div class="empty"><span class="empty__ic"><svg viewBox="0 0 24 24" fill="none" width="28" height="28" aria-hidden="true"><path d="M2.5 3.5h2.6l2.3 11.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2l1.6-7.3H6.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.6" cy="19.8" r="1.4" fill="currentColor"/><circle cx="17.2" cy="19.8" r="1.4" fill="currentColor"/></svg></span>' +
          '<p class="h3">Your cart is empty</p>' +
          '<p class="muted" style="margin-top:6px">Nothing in here yet — start with what just landed.</p>' +
          '<a class="btn btn--primary" href="/collections/new-arrivals" style="margin-top:18px">Shop new arrivals</a></div>';
      } else {
        body.innerHTML = cart.items.map(lineHtml).join('');
      }
    }
    $$('[data-cart-total]').forEach(function (n) { n.textContent = money(cart.total_price); });
    var foot = $('[data-cart-foot]');
    if (foot) foot.hidden = cart.item_count === 0;

    var fb = $('[data-freebar]');
    if (fb) {
      var thr = parseInt(fb.getAttribute('data-threshold'), 10) || 0;
      var msg = $('[data-freebar-msg]', fb), fill = $('[data-freebar-fill]', fb);
      fb.hidden = thr <= 0 || cart.item_count === 0;
      if (thr > 0 && msg) {
        var left = thr - cart.total_price;
        var done = left <= 0;
        fb.classList.toggle('is-done', done);
        msg.innerHTML = done
          ? '<strong>Free standard shipping unlocked.</strong>'
          : 'You are <strong>' + money(left) + '</strong> away from free standard shipping.';
        if (fill) fill.style.width = Math.min(100, (cart.total_price / thr) * 100) + '%';
      }
    }
  }

  function getCart(open) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        renderCart(c);
        if (open) openPanel($('[data-cart-drawer]'));
        return c;
      })
      .catch(function () {});
  }

  function changeLine(key, qty, el) {
    var row = el && el.closest ? (el.closest('.line') || el.closest('.cartline')) : null;
    if (row) row.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (c) {
        // the cart page is rendered in Liquid (shipping meter, totals) — reload it
        if (onCartPage && !(el && el.closest && el.closest('[data-cart-drawer]'))) { window.location.reload(); return c; }
        renderCart(c);
        return c;
      })
      .catch(function () {
        if (row) row.classList.remove('is-busy');
        toast('Could not update your cart.', 'err');
      });
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-cq]');
    if (step) {
      var key = step.getAttribute('data-cq');
      var scope = step.closest('.line') || step.closest('.cartline') || document;
      var inp = $('[data-cqi="' + key + '"]', scope);
      var next = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(step.getAttribute('data-d'), 10));
      changeLine(key, next, step);
      return;
    }
    var rm = e.target.closest('[data-crm]');
    if (rm) changeLine(rm.getAttribute('data-crm'), 0, rm);
  });

  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-cqi]');
    if (i) changeLine(i.getAttribute('data-cqi'), Math.max(0, parseInt(i.value, 10) || 0), i);
  });

  // the drawer opening is the confirmation — a toast on top of it only covers its buttons
  function added() { getCart(true); }

  // Enter in the quantity box would "click" the first button (Buy It Now) — keep it on the page instead.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-atc-form] input')) e.preventDefault();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-atc-form]');
    if (!form) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[data-atc-btn]') || form.querySelector('[type=submit]');
    var buyNow = !!(btn && btn.hasAttribute('data-buy-now'));
    if (btn) btn.classList.add('is-busy');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { if (btn) btn.classList.remove('is-busy'); toast(res.j.description || res.j.message || 'Could not add to cart.', 'err'); return; }
        if (buyNow) { window.location.href = '/checkout'; return; }
        if (btn) btn.classList.remove('is-busy');
        added();
      })
      .catch(function () {
        if (btn) btn.classList.remove('is-busy');
        toast('Network error. Please try again.', 'err');
      });
  });

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quickadd]');
    if (!q) return;
    e.preventDefault();
    if (q.classList.contains('is-busy')) return;
    q.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(q.getAttribute('data-quickadd')), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        q.classList.remove('is-busy');
        if (!res.ok) { toast(res.j.description || 'Could not add to cart.', 'err'); return; }
        added();
      })
      .catch(function () { q.classList.remove('is-busy'); toast('Network error.', 'err'); });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-sticky-add]')) return;
    e.preventDefault();
    var form = $('[data-atc-form]');
    if (!form) return;
    var atc = form.querySelector('[data-atc-btn]');
    if (form.requestSubmit) form.requestSubmit(atc || undefined);
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  if ($('[data-cart-drawer]')) getCart(false);

  /* ------------------------------------------------------- header search */
  var sbox = $('[data-sbox]');
  var sinput = $('[data-search-input]');
  var sdrop = $('[data-search-drop]');
  var sres = $('[data-search-results]');

  function openSearch() {
    if (!sdrop) return;
    sdrop.hidden = false;
    searchOpen = true;
    if (sinput) sinput.setAttribute('aria-expanded', 'true');
    closeDept();
  }
  function closeSearch() {
    if (!sdrop || sdrop.hidden) return;
    sdrop.hidden = true;
    searchOpen = false;
    if (sinput) sinput.setAttribute('aria-expanded', 'false');
  }

  if (sbox && sinput && sdrop && sres) {
    var idle = sres.innerHTML, timer, last = '', seq = 0;

    var render = function (q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var collections = r.collections || [];
      var queries = r.queries || [];
      if (!products.length && !collections.length) {
        sres.innerHTML = '<p class="sdrop__none">No matches for &ldquo;' + esc(q) + '&rdquo;. Try a material, a colour or a category.</p>' + idle;
        return;
      }
      var html = '';
      if (queries.length || collections.length) {
        html += '<div class="sdrop__sec"><p class="sdrop__lb">Suggestions</p><div class="sdrop__pills">' +
          queries.slice(0, 4).map(function (s) { return '<a class="pill" href="' + esc(s.url) + '">' + esc(s.text) + '</a>'; }).join('') +
          collections.map(function (c) { return '<a class="pill" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') +
          '</div></div>';
      }
      if (products.length) {
        html += '<div class="sdrop__sec"><p class="sdrop__lb">Products</p><div class="sres">' +
          products.map(function (p) {
            var src = p.featured_image && p.featured_image.url ? sized(p.featured_image.url, 120) : (p.image ? sized(p.image, 120) : '');
            return '<a class="sres__i" href="' + esc(p.url) + '">' +
              (src ? '<img src="' + esc(src) + '" alt="" width="52" height="52" loading="lazy">' : '<span class="sres__ph"></span>') +
              '<span class="sres__t">' + esc(p.title) + '</span>' +
              '<span class="sres__p">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
          }).join('') + '</div></div>';
      }
      html += '<a class="sdrop__all" href="' + (T.routes && T.routes.search ? T.routes.search : '/search') +
        '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
      sres.innerHTML = html;
    };

    var suggest = function () {
      var q = sinput.value.trim();
      if (q.length < 2) { sres.innerHTML = idle; last = ''; return; }
      if (q === last) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = q;
        var mine = ++seq;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (d) { if (mine === seq) render(q, d); })
          .catch(function () {});
      }, 180);
    };

    sinput.addEventListener('focus', function () { openSearch(); suggest(); });
    sinput.addEventListener('input', function () { openSearch(); suggest(); });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-sbox]')) closeSearch();
    });
    sbox.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = $$('.sres__i, .sdrop__pills .pill, .sdrop__all', sdrop);
      if (!items.length) return;
      e.preventDefault();
      var i = items.indexOf(document.activeElement);
      i = e.key === 'ArrowDown' ? Math.min(items.length - 1, i + 1) : i - 1;
      if (i < 0) sinput.focus(); else items[i].focus();
    });
  }

  /* --------------------------------------------------------------- rails */
  function initRail(rail) {
    var track = $('[data-rail-track]', rail);
    var prev = $('[data-rail="prev"]', rail);
    var next = $('[data-rail="next"]', rail);
    if (!track || !prev || !next) return;
    function step() { return Math.max(200, track.clientWidth * 0.9); }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce() ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce() ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    rail.ttSync = sync;
    setTimeout(sync, 60);
  }
  $$('[data-rail]').forEach(function (n) { if (n.querySelector('[data-rail-track]')) initRail(n); });

  /* ------------------------------------------------------------- gallery */
  $$('[data-gal]').forEach(function (gal) {
    var track = $('[data-gal-track]', gal);
    var figs = $$('[data-gal-fig]', gal);
    var thumbs = $$('[data-gal-th]', gal);
    var dots = $$('[data-gal-dot]', gal);
    var stage = $('[data-gal-stage]', gal);
    if (!figs.length) return;
    var index = 0;

    function mark(i) {
      index = i;
      figs.forEach(function (n, k) { n.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (n, k) {
        n.classList.toggle('is-on', k === i);
        n.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      dots.forEach(function (n, k) { n.classList.toggle('is-on', k === i); });
      var now = $('[data-gal-now]', gal);
      if (now) now.textContent = i + 1;
    }
    function show(i) {
      if (i < 0 || i >= figs.length) return;
      mark(i);
      if (track && track.scrollWidth > track.clientWidth + 4) {
        track.scrollTo({ left: figs[i].offsetLeft - track.offsetLeft, behavior: reduce() ? 'auto' : 'smooth' });
      }
    }
    gal.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gal-th]');
      if (t) show(thumbs.indexOf(t));
    });
    $$('[data-gal-step]', gal).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation(); // the stage behind it opens the lightbox
        show((index + parseInt(b.getAttribute('data-gal-step'), 10) + figs.length) % figs.length);
      });
    });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          if (track.scrollWidth <= track.clientWidth + 4) return;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          mark(Math.max(0, Math.min(i, figs.length - 1)));
        });
      }, { passive: true });
    }

    if (stage) {
      stage.addEventListener('mousemove', function (e) {
        if (isSmall() || reduce()) return;
        var img = figs[index] && figs[index].querySelector('img');
        if (!img) return;
        var r = stage.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' +
                                    ((e.clientY - r.top) / r.height * 100) + '%';
      });
      stage.addEventListener('mouseenter', function () { if (!isSmall() && !reduce()) stage.classList.add('is-zoom'); });
      stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); });
      stage.addEventListener('click', function () {
        if (isSmall()) return;
        var box = $('[data-lightbox]');
        var img = figs[index] && figs[index].querySelector('img');
        if (!box || !img) return;
        $('[data-lightbox-img]', box).src = img.currentSrc || img.src;
        openPanel(box);
      });
    }

    gal.ttShow = function (mediaId) {
      for (var k = 0; k < figs.length; k++) {
        if (figs[k].getAttribute('data-gal-fig') === String(mediaId)) { show(k); return; }
      }
    };
  });

  /* ------------------------------------------------------------ variants */
  $$('[data-variants]').forEach(function (root) {
    var json = $('[data-variant-json]', root);
    var data;
    try { data = JSON.parse(json.textContent); } catch (err) { return; }
    if (!data || !data.length) return;
    var idInput = $('[data-variant-id]', root);

    function update() {
      var inputs = $$('input[data-opt]', root);
      var chosen = $$('input[data-opt]:checked', root).map(function (i) { return i.value; });
      var v;

      if (!inputs.length) {
        v = data[0];
      } else {
        v = data.find(function (x) {
          return x.options.every(function (o, idx) { return o === chosen[idx]; });
        });
        inputs.forEach(function (i) {
          var pos = parseInt(i.getAttribute('data-opt'), 10);
          var test = chosen.slice();
          test[pos] = i.value;
          i.disabled = !data.some(function (x) {
            return x.options.every(function (o, idx) { return idx > pos ? true : o === test[idx]; });
          });
        });
        $$('[data-opt-value]', root).forEach(function (n) {
          n.textContent = chosen[parseInt(n.getAttribute('data-opt-value'), 10)] || '';
        });
      }

      var btn = $('[data-atc-btn]', root);
      var buyNow = $('[data-buy-now]', root);
      var price = $('[data-pdp-price]', root);
      var was = $('[data-pdp-was]', root);
      var wasLine = $('[data-pdp-wasline]', root);
      var sku = $('[data-pdp-sku]');
      var stock = $('[data-pdp-stock]', root);
      var fee = $('[data-ship-fee]', root);
      var sticky = $('[data-sticky-price]');
      var stickyBtn = $('[data-sticky-add]');

      if (!v) {
        if (btn) { btn.disabled = true; $('.btn__label', btn).textContent = 'Unavailable'; }
        if (buyNow) buyNow.disabled = true;
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (price) price.textContent = money(v.price);
      if (sticky) sticky.textContent = money(v.price);
      if (was) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        was.textContent = onSale ? money(v.compare_at_price) : '';
        if (wasLine) wasLine.hidden = !onSale; else was.hidden = !onSale;
      }
      if (fee) {
        var thr = parseInt(fee.getAttribute('data-threshold'), 10) || 0;
        fee.textContent = thr > 0 && v.price >= thr ? 'Free' : money(T.shipFee || 695);
      }
      if (sku && v.sku) sku.textContent = v.sku;
      if (btn) {
        btn.disabled = !v.available;
        $('.btn__label', btn).textContent = v.available ? 'Add to cart' : 'Out of stock';
      }
      if (buyNow) buyNow.disabled = !v.available;
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (stock) {
        stock.textContent = v.available ? 'In stock — ships in 3–5 business days' : 'Currently out of stock';
        stock.classList.toggle('stock--out', !v.available);
      }
      if (v.featured_media) {
        var g = $('[data-gal]');
        if (g && g.ttShow) g.ttShow(v.featured_media);
      }
      if (inputs.length && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[data-opt]')) update();
    });
    update();
  });

  /* ------------------------------------------------------- qty steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var inp = b.parentNode.querySelector('input');
    if (!inp) return;
    inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
  });

  /* ------------------------------------------------------ sticky buy bar */
  (function () {
    var sticky = $('[data-stickybuy]');
    var anchor = $('[data-buy-anchor]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  })();

  /* -------------------------------------------- footer columns on phones */
  if (isSmall()) $$('.ftr__col[open]').forEach(function (d) { d.removeAttribute('open'); });

  /* ------------------------------------------------------------ image fade */
  $$('img.fade').forEach(function (img) {
    if (img.complete && img.naturalWidth) img.classList.add('is-in');
    else img.addEventListener('load', function () { img.classList.add('is-in'); }, { once: true });
  });

  /* --------------------------------------------------------- back to top */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-totop]')) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: reduce() ? 'auto' : 'smooth' });
  });

  /* ------------------------------------------------- contact form anchor */
  var posted = $('[data-form-msg]');
  if (posted) posted.scrollIntoView({ block: 'center' });

  /* ---------------------------------------------------------- watchlist
     Hearts on cards, "Add to Watchlist" on the item page, "Save for later"
     in the cart. The list lives in this browser only (localStorage). */
  var WATCH = 'tt_watch';
  function paintWatch() {
    var list = handles(WATCH);
    $$('[data-watch]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-watch')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var t = b.getAttribute('aria-label');
      if (t && / Watchlist$/.test(t)) {
        b.setAttribute('aria-label', t.replace(/^(Add|Remove) /, on ? 'Remove ' : 'Add ')
          .replace(/ (to|from) your Watchlist$/, on ? ' from your Watchlist' : ' to your Watchlist'));
      }
    });
    $$('[data-watch-count]').forEach(function (n) { n.textContent = list.length; n.hidden = !list.length; });
  }
  function setWatch(h, on) {
    var list = handles(WATCH).filter(function (x) { return x !== h; });
    if (on) list.unshift(h);
    store.set(WATCH, list.slice(0, 200));
    paintWatch();
  }
  function watchEmpty() {
    var grid = $('[data-watch-grid]'), empty = $('[data-watch-empty]');
    var n = grid ? grid.children.length : 0;
    if (empty) empty.hidden = n > 0;
    $$('[data-watch-total]').forEach(function (x) { x.textContent = n; });
    var clr = $('[data-watch-clear]');
    if (clr) clr.hidden = n === 0;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-watch]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-watch');
    var on = handles(WATCH).indexOf(h) < 0;
    setWatch(h, on);
    b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
    toast(on ? 'Added to your Watchlist' : 'Removed from your Watchlist');
    var grid = $('[data-watch-grid]');
    if (!on && grid && grid.contains(b)) {
      var card = b.closest('.card');
      if (card) card.remove();
      watchEmpty();
    }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-save-later]');
    if (!b) return;
    e.preventDefault();
    setWatch(b.getAttribute('data-handle'), true);
    toast('Saved to your Watchlist');
    changeLine(b.getAttribute('data-save-later'), 0, b);
  });
  window.addEventListener('storage', function (e) { if (e.key === WATCH) paintWatch(); });
  paintWatch();

  (function () {
    var grid = $('[data-watch-grid]');
    if (!grid) return;
    var clr = $('[data-watch-clear]');
    if (clr) clr.addEventListener('click', function () { store.set(WATCH, []); grid.innerHTML = ''; paintWatch(); watchEmpty(); });
    var list = handles(WATCH);
    if (!list.length) { watchEmpty(); return; }
    fetchProducts(list).then(function (rows) {
      var gone = rows.filter(function (r) { return r && r._gone; }).map(function (r) { return r._gone; });
      if (gone.length) store.set(WATCH, handles(WATCH).filter(function (h) { return gone.indexOf(h) < 0; }));
      grid.innerHTML = rows.filter(function (r) { return r && !r._gone; }).map(cardHtml).join('');
      paintWatch();
      watchEmpty();
    });
  })();

  /* ---------------------------------------------------- recently viewed */
  var RECENT = 'tt_recent';
  (function () {
    var pdp = $('[data-product-handle]');
    if (!pdp) return;
    var me = pdp.getAttribute('data-product-handle');
    store.set(RECENT, [me].concat(handles(RECENT).filter(function (h) { return h !== me; })).slice(0, 24));
  })();
  $$('[data-recent]').forEach(function (sec) {
    var track = $('[data-recent-track]', sec);
    var skip = sec.getAttribute('data-recent-skip') || '';
    var max = parseInt(sec.getAttribute('data-recent-max'), 10) || 12;
    var list = handles(RECENT).filter(function (h) { return h !== skip; }).slice(0, max);
    var clr = $('[data-recent-clear]', sec);
    if (clr) clr.addEventListener('click', function () { store.set(RECENT, skip ? [skip] : []); sec.hidden = true; });
    if (!track || !list.length) return;
    fetchProducts(list).then(function (rows) {
      var ok = rows.filter(function (r) { return r && !r._gone; });
      if (!ok.length) return;
      track.innerHTML = ok.map(cardHtml).join('');
      sec.hidden = false;
      paintWatch();
      var rail = $('[data-rail]', sec);
      if (rail && rail.ttSync) setTimeout(rail.ttSync, 30);
    });
  });

  /* --------------------------------------------- gallery / list switch */
  (function () {
    var grid = $('[data-view-grid]');
    var btns = $$('[data-view-btn]');
    if (!grid || !btns.length) return;
    var key = 'tt_view_' + ((document.body.className.match(/tmpl-([a-z_-]+)/) || [0, 'page'])[1]);
    function apply(v) {
      grid.classList.toggle('is-list', v === 'list');
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-view-btn') === v ? 'true' : 'false'); });
    }
    apply(store.get(key, grid.getAttribute('data-view-default') || 'grid'));
    btns.forEach(function (b) {
      b.addEventListener('click', function () { var v = b.getAttribute('data-view-btn'); store.set(key, v); apply(v); });
    });
  })();

  /* -------------------------------------------------------- hero carousel
     One slide at a time. Auto-advance pauses on hover, keyboard focus, a
     hidden tab, the pause button, and never runs for reduced motion. */
  $$('[data-hero]').forEach(function (hero) {
    var track = $('[data-hero-track]', hero);
    var slides = $$('[data-hero-slide]', hero);
    var dots = $$('[data-hero-dot]', hero);
    var now = $('[data-hero-now]', hero);
    var pause = $('[data-hero-pause]', hero);
    if (!track || slides.length < 2) return;
    var i = 0, timer = null, paused = false, held = false;
    var delay = parseInt(hero.getAttribute('data-hero-delay'), 10) || 6000;
    var auto = hero.hasAttribute('data-hero-auto') && !reduce();
    function mark(n) {
      i = n;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
      if (now) now.textContent = n + 1;
    }
    function go(n) {
      n = (n + slides.length) % slides.length;
      track.scrollTo({ left: slides[n].offsetLeft, behavior: reduce() ? 'auto' : 'smooth' });
      mark(n);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        mark(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth)))));
      });
    }, { passive: true });
    function tick() { if (!paused && !held && !document.hidden) go(i + 1); }
    function restart() { clearInterval(timer); if (auto && !paused) timer = setInterval(tick, delay); }
    $$('[data-hero-go]', hero).forEach(function (b) {
      b.addEventListener('click', function () { go(i + parseInt(b.getAttribute('data-hero-go'), 10)); restart(); });
    });
    if (pause) {
      if (!auto) pause.hidden = true;
      pause.addEventListener('click', function () {
        paused = !paused;
        pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pause.setAttribute('aria-label', paused ? 'Play slides' : 'Pause slides');
        hero.classList.toggle('is-paused', paused);
        restart();
      });
    }
    hero.addEventListener('mouseenter', function () { held = true; });
    hero.addEventListener('mouseleave', function () { held = false; });
    hero.addEventListener('focusin', function () { held = true; });
    hero.addEventListener('focusout', function () { held = false; });
    window.addEventListener('resize', function () { track.scrollTo({ left: slides[i].offsetLeft, behavior: 'auto' }); });
    restart();
  });
})();
